// Recognises the expediente copy of an annulled radicado. The copy is never
// deleted; it only has to say it is void.
//
// handleCorrespondence marks the copies when the radicado is annulled
// (`cancellation` on the expedient_documents doc). A copy it missed — one cloned
// a moment after the annulment, or one whose marking failed — is still
// recognised here by its storage path against the radicados the expediente
// lists, so the radicado's own status stays the authority either way.

// Firebase download URLs encode the path, storage.googleapis.com ones don't.
const storagePathOf = (url) => {
  try {
    return decodeURIComponent(new URL(String(url)).pathname);
  } catch (_) {
    return null;
  }
};

// The radicado id a "Comunicaciones Oficiales" copy was cloned from: its file
// is <type>/<expedientId>/<filedId>.pdf.
export const sourceFiledIdOf = (document) => {
  const path = storagePathOf(document?.documentUrl);
  const match = path && path.match(/\/([^/]+)\.pdf$/i);
  return match ? match[1] : null;
};

/**
 * What to show for a copy of an annulled radicado, or null when it isn't one.
 * The result has the shape FiledCancellationNotice / getCancellationInfo read:
 * `{ filedId, cancellation, ... }`.
 *
 * @param {object} document - expedient_documents doc
 * @param {Array<object>} fileds - the radicados the expediente lists
 * @param {string} expedientId
 */
export const annulledSourceOf = (document, fileds, expedientId) => {
  if (document?.cancellation) {
    return { ...document, filedId: document.cancellation.sourceFiledId || null };
  }
  const path = storagePathOf(document?.documentUrl);
  if (!path) return null;
  return (fileds || []).find((filed) =>
    filed
    && filed.status === "CANCELLED"
    && (
      path.endsWith(`/${expedientId}/${filed.filedId}.pdf`)
      || (Array.isArray(filed.annexes) ? filed.annexes : []).some(
        (annex) => annex?.id && path.endsWith(`/${expedientId}/${annex.id}`)
      )
    )
  ) || null;
};
